<script>
    import {PAGE_ID, router, navigateTo} from "../../stores/router";
</script>


<div class="absolute top-16 right-0 bottom-0 left-0 overflow-y-auto" class:hidden={$router.current_page !== PAGE_ID.LOGIN}>

    <!-- TODO implement Login Page -->
    <h2>Login Page</h2>

</div>


<style></style>